export const parseDepositLimit = (value) => parseFloat(String(value || '').replace(/[^0-9.]/g, ''));

export const getDepositAmountError = (amount, paymentMethod, { isCashDeposit = false } = {}) => {
    const numericValue = parseFloat(amount);
    const min = parseDepositLimit(paymentMethod?.minAmount);
    const max = parseDepositLimit(paymentMethod?.maxAmount);
    const usdValue = isCashDeposit ? parseFloat(amount) : numericValue;

    if (amount === '' || amount === null || amount === undefined) {
        return 'Please enter deposit amount';
    }
    if (isNaN(numericValue) || numericValue <= 0) {
        return 'Please enter valid number';
    }
    if (!isNaN(min) && usdValue < min) {
        return `Minimum deposit is ${paymentMethod?.minAmount}`;
    }
    if (!isNaN(max) && usdValue > max) {
        return `Maximum deposit is ${paymentMethod?.maxAmount}`;
    }
    return '';
};
